import { useState } from 'react';
import type { FormEvent } from 'react';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../auth/AuthContext';
import { errorMessage } from '../hooks/useApi';

export function LoginPage() {
  const { login, notice } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(email, password);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-full flex items-center justify-center bg-[#090814] p-6">
      <form
        onSubmit={submit}
        className="w-full max-w-sm bg-[#120d1a] border border-[#241b33] rounded-2xl p-7 shadow-2xl space-y-5"
      >
        <div>
          <h1 className="text-xl font-bold text-white">Sign in to Drameeka</h1>
          <p className="text-xs text-gray-400 mt-1">Use the email and password you were given.</p>
        </div>

        {notice && (
          <p className="text-xs text-amber-300 bg-amber-500/10 border border-amber-500/30 rounded-lg px-3 py-2">
            {notice}
          </p>
        )}

        <label className="block">
          <span className="block text-xs font-semibold text-gray-300 mb-1">Email</span>
          <input
            type="email"
            required
            autoFocus
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-3 py-2 bg-[#171022] border border-[#2c2140] rounded-lg text-sm text-white focus:outline-none focus:border-violet-500"
          />
        </label>

        <label className="block">
          <span className="block text-xs font-semibold text-gray-300 mb-1">Password</span>
          <input
            type="password"
            required
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-3 py-2 bg-[#171022] border border-[#2c2140] rounded-lg text-sm text-white focus:outline-none focus:border-violet-500"
          />
        </label>

        {error && (
          <p role="alert" className="text-xs text-rose-300">
            {error}
          </p>
        )}

        <button
          type="submit"
          disabled={busy}
          className="w-full flex items-center justify-center gap-2 py-2.5 rounded-lg bg-violet-600 hover:bg-violet-500 text-white text-sm font-semibold disabled:opacity-60"
        >
          {busy && <Loader2 className="w-4 h-4 animate-spin" />}
          Sign in
        </button>
      </form>
    </div>
  );
}
